module.exports = __webpack_public_path__ + "img/melegfoliazas-thumb.b91a1bac.jpg";